import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';

export default function LightSwitch() {
  const { isDark, toggleTheme } = useTheme();
  const { t } = useLanguage();

  return (
    <button data-testid="light-switch-toggle" onClick={toggleTheme} className="relative flex flex-col items-center gap-1" aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <div className="relative w-10 sm:w-14 h-16 sm:h-24 rounded-lg bg-gradient-to-b from-neutral-200 to-neutral-300 dark:from-neutral-700 dark:to-neutral-800 shadow-[inset_0_2px_4px_rgba(0,0,0,0.1),0_1px_2px_rgba(255,255,255,0.1)] border border-neutral-300 dark:border-neutral-600 overflow-hidden">
        <div className="absolute inset-1.5 sm:inset-2 rounded-md bg-gradient-to-b from-neutral-100 to-neutral-200 dark:from-neutral-600 dark:to-neutral-700 shadow-inner">
          <motion.div className="absolute left-0 right-0 h-[45%] rounded-md bg-gradient-to-b from-white to-neutral-100 dark:from-neutral-500 dark:to-neutral-600 shadow-md border border-neutral-200 dark:border-neutral-500 cursor-pointer" animate={{ y: isDark ? '122%' : '0%' }} transition={{ type: 'spring', stiffness: 500, damping: 30 }}>
            <div className="absolute inset-x-2 top-1/2 -translate-y-1/2 flex flex-col gap-1">
              <div className="h-px bg-neutral-300 dark:bg-neutral-400 rounded-full" />
              <div className="h-px bg-neutral-300 dark:bg-neutral-400 rounded-full" />
              <div className="h-px bg-neutral-300 dark:bg-neutral-400 rounded-full" />
            </div>
          </motion.div>
        </div>
        {isDark && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="absolute top-1.5 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-brand shadow-[0_0_8px_rgba(227,37,16,0.8)]" />
        )}
      </div>
      <span className="text-xs font-heading tracking-wider text-muted-foreground uppercase">{isDark ? t('off') : t('on')}</span>
    </button>
  );
}
